import { useLocation, useNavigate, matchPath } from "react-router-dom";
import { BenefitsRoutes } from "@leagueplatform/benefits";
import { useIntl } from "@leagueplatform/locales";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { PageHero } from "components/page-hero/page-hero.component";

// Wraps the SDK's `<BenefitsRoutes>` and adds emblem-web-only affordances
// on specific benefits subpaths:
//   * `/benefits/id-cards`         — injects the `PageHero` used by other
//                                    native app-owned pages (QA #missing-
//                                    page-header on ID Cards).
//   * `/benefits/coverage-details` — wraps children in `.cx-coverage-
//                                    details` so scoped CSS overrides in
//                                    `index.css` can target the OON/INN
//                                    tables without leaking to accordions
//                                    on other pages.
// The SDK still owns rendering of the Masonry tree below.
const ID_CARDS_PATH = `${APP_MANAGED_ROUTES.BENEFITS}/id-cards`;
const COVERAGE_DETAILS_PATH = `${APP_MANAGED_ROUTES.BENEFITS}/coverage-details`;

export const BenefitsShell = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const navigate = useNavigate();

  const isIdCards = Boolean(
    matchPath({ path: ID_CARDS_PATH, end: false }, location.pathname)
  );
  const isCoverageDetails = Boolean(
    matchPath({ path: COVERAGE_DETAILS_PATH, end: false }, location.pathname)
  );

  const pageClassName = isCoverageDetails ? "cx-coverage-details" : undefined;

  // ID Cards is reachable from multiple entry points (Benefits tab,
  // Approval status, etc.), matching mobile's nav stack. `location.key` is
  // `"default"` only for the first history entry (a direct link/fresh tab),
  // which has nowhere to go back to — everything else came from somewhere
  // in-app, so `navigate(-1)` returns to that entry point instead of always
  // landing on Benefits.
  const handleIdCardsBack = () => {
    const cameFromDirectLink = !location.key || location.key === "default";
    if (cameFromDirectLink) {
      navigate(APP_MANAGED_ROUTES.BENEFITS);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      {isIdCards && (
        <PageHero
          title={formatMessage({ id: "STR_PAGE_ID_CARDS" })}
          backLabel={formatMessage({ id: "STR_BACK" })}
          onBack={handleIdCardsBack}
        />
      )}
      {pageClassName ? (
        <div className={pageClassName}>
          <BenefitsRoutes />
        </div>
      ) : (
        <BenefitsRoutes />
      )}
    </>
  );
};
